import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined'
import ProgressBar from './ProgressBar';
import TranslationContent_IEP from './TranslationContents/TranslationContent_IEP'
import TranslationContent_Transcript from './TranslationContents/TranslationContent_Transcript'
import TranslationContent_Letter from './TranslationContents/TranslationContent_Letter'
import TranslationContent_SchoolDocument from './TranslationContents/TranslationContent_SchoolDocument'
import TranslationContent_Evaluations from './TranslationContents/TranslationContent_Evaluations'
import TranslationContent_Other from './TranslationContents/TranslationContent_Other'
import NavBottom_Call_Mail_Youtube from './NavBottom_Call_Mail_Youtube'
import MultipleSelect_Checkbox from './MultiSelect_Checkbox'
import Dropdown_Advanced from './Dropdown_Advanced'
import TextFields_Outlined_Phone from './TextMasks/TextMask_Phone'
import MySectionBlock from './MySectionBlock'


import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

/* Button */
import Button from '@material-ui/core/Button';
/* Grid */
import { createTheme, ThemeProvider } from "@material-ui/core";
/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import districts from '../data/districts.json'
import schools from '../data/schools.json'
import grades from '../data/grades.json'
/*import genders from '../data/genders.json'*/
import whom_child_resides from '../data/whom_child_resides.json'
import motherFatherGuardian from '../data/motherFatherGuardian.json'

import ColumnStatus from './ColumnStatus'

/* Bottom Nav */


/* Context */
import ContentContext from './ContentContext'
import { TranslationColumn1Context } from './TranslationContexts/TranslationColumn1Context'
import { useDispatch, useSelector } from 'react-redux'
import { studentFirstName_bilUpdated, studentLastName_bilUpdated, countryOfOrigin_bilUpdated, DOB_bilUpdated, gender_bilUpdated, yearsInUS_bilUpdated, grade_bilUpdated, childResidesWith_bilUpdated, mfg1_bilUpdated, mfgName1_bilUpdated, mfg2_bilUpdated, mfgName2_bilUpdated, childsResidesWithOther_bilUpdated, homeAddress_bilUpdated, homeNum_bilUpdated, workNum_bilUpdated, cellNum_bilUpdated, nativeLanguage_bilUpdated, nativeLanguageOther_bilUpdated, districtDropdown_bilUpdated, schoolDropdown_bilUpdated, CSEDate_bilUpdated, currentTeacherName_bilUpdated, currentTeacherEmail_bilUpdated, psychologistName_bilUpdated, psychologistEmail_bilUpdated, speechPathologistName_bilUpdated, speechPathologistEmail_bilUpdated, districtContactName_bilUpdated, districtContactTitle_bilUpdated, districtContactAddress_bilUpdated, districtContactPhone_bilUpdated, districtContactEmail_bilUpdated, approverName_bilUpdated, approverTitle_bilUpdated, approverEmail_bilUpdated, coser_bilUpdated, reason_bilUpdated, alreadyClassified_bilUpdated, classification_bilUpdated, consentToEvalAttached_billUpdated, priorWrittenNoticeAttached_bilUpdated, homeLangQuestAttached_bilUpdated, nonVerbSecDiagnosed_bilUpdated, studentEnterSchoolDate_bilUpdated, nameOfOtherSchoolAttended_bilUpdated, typesOfEvals_bilUpdated, typesOfEvals_other_bilUpdated, diagnosedCondition_bilUpdated, diagnosedConditionText_bilUpdated, services_bilUpdated, generalHealth_bilUpdated, generalHealthText_bilUpdated, medication_bilUpdated, medicationText_bilUpdated, wearsGlasses_bilUpdated, wearsGlassesText_bilUpdated, pedRestrictions_bilUpdated, pedRestrictionsText_bilUpdated, physicalExamDate_bilUpdated, h_freq_audiology_bilUpdated, h_indv_audiology_bilUpdated, h_freq_visTherapy_bilUpdated, h_indv_visTherapy_bilUpdated, h_freq_resourceRoom_bilUpdated, h_indv_resourceRoom_bilUpdated, h_freq_counseling_bilUpdated, h_indv_counseling_bilUpdated, h_freq_speechLang_bilUpdated, h_indv_speechLang_bilUpdated, h_freq_physTherapy_bilUpdated, h_indv_physTherapy_bilUpdated, h_freq_occTherapy_bilUpdated, h_indv_occTherapy_bilUpdated, i_freq_Reading_bilUpdated, i_indv_Reading_bilUpdated, i_freq_AISMath_bilUpdated, i_indv_AISMath_bilUpdated, i_freq_AAtL_bilUpdated, i_indv_AAtL_bilUpdated, i_freq_AdjAssign_bilUpdated, i_indv_AdjAssign_bilUpdated, i_freq_schedAdj_bilUpdated, i_indv_schedAdj_bilUpdated, i_freq_indvProgBasedOnSkill_bilUpdated, i_indv_indvProgBasedOnSkill_bilUpdated, i_freq_speechImprov_bilUpdated, i_indv_speechImprov_bilUpdated, i_freq_tutoring_bilUpdated, i_indv_tutoring_bilUpdated, i_freq_consulServices_bilUpdated, i_indv_consulServices_bilUpdated, i_other_bilUpdated, areas_bilUpdated, addConcerns_bilUpdated, suspDetails_bilUpdated, notes_bilUpdated, docToAccessFiles_bilUpdated, consentToEvalAttachedFiles_bilUpdated, priorWrittenNoticeAttachedFiles_bilUpdated, homeLangQuestAttachedFiles_bilUpdated } from '../redux/slices/assessmentSlice'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import MultipleSelect from './MultiSelect_Checkbox';

/* Accordion */
import Directions_Accordion from './Directions_Accordion'
/* Date Picker */
import DatePicker_Advanced from './DatePicker_Advanced'
import DatePicker_Simple from './DatePicker_Simple'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FcCalendar } from 'react-icons/fc';

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import Checkbox_Regular from './Checkbox_Regular';
import { red } from '@material-ui/core/colors';


const BilingualAssessmentContent = ({ handleContinueButton, handleProgressBarChange }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  //const { dataContext, setDataContext } = useContext(TranslationDataContext)

  const dispatch = useDispatch();
  const assessmentState = useSelector((state) => state.assessment); // Access translation state
  const [progressBarClass, setProgressBarClass] = useState('')


  const dataForQB = useTranslation()
  const setDataForQB = useTranslationUpdate()
  //const { dataForQB, setDataForQB } = useContext(TranslationDataContext)
  //alert(dataForQB.dueDateText+"data for qb")

  const useStyles = createTheme((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  //////////////////////////////////////////////////////////////
  // MJS - 3/31/25 - cut off bilingual assessments from may 20 - july 1 2025
  //////////////////////////////////////////////////////////////
  let todaysDate = new Date();
  let cutoffDateRange = {
    start: new Date(2025,4,20,15),
    //start: new Date(2025,2,31,12),
    end: new Date(2025,6,1)
  }
  let isCutoff = todaysDate >= cutoffDateRange.start && todaysDate < cutoffDateRange.end ? true : false;

  //const classes = useStyles();

  //////////////////////////////////////////////////////////////
  // COLUMN VALIDATION - UI TO SHOW THIS
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 1
  //////////////////////////////////////////////////////////////
  const [col1RequiredFields, setCol1RequiredFields] = useState({})
  const [column1Complete, setColumn1Complete] = useState(false)
  const updateColumn1Count = (id, valueInInput) => {
    let allFilledOut = true;
    for (var key in col1RequiredFields) {
      //console.log("key " + key + " has value " + col1RequiredFields[key]);
      if (key == id) {
        col1RequiredFields[key] = valueInInput
        // Set the POST obj
        dataForQB[key] = valueInInput;
      }
      if (col1RequiredFields[key] == "") {
        allFilledOut = false;
      }
      
    }
    setColumn1Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("TESTING IF THIS IS RUNNING")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn1ColumnStatus = () => {
    return <ColumnStatus complete={column2Complete} />
  }
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 2
  //////////////////////////////////////////////////////////////
  // States
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [column2Complete, setColumn2Complete] = useState(false)
  const [renderOtherLang, setRenderOtherLang] = useState(false)
  const [renderOtherWhom, setRenderOtherWhom] = useState(false)
  const [col2RequiredFields, setCol2RequiredFields] = useState(
    {
      studentFirstName_bil: '',
      studentLastName_bil: '',
      DOB_bil: '',
      grade_bil: '',
      childResidesWith_bil: '',
      mfg1_bil: '',
      mfgName1_bil: '',
      childsResidesWithOther_bil: '',
      homeAddress_bil: '',
      homeNum_bil: '',
      nativeLanguage_bil: '',
      nativeLanguageOther_bil: '',
      districtDropdown_bil: '',
      schoolDropdown_bil: ''
    }
  )

  const updateNonRequireField = (id, valueInInput) =>{
    dataForQB[id] = valueInInput
  }

  const updateColumn2Count = (id, valueInInput) => {
    col2RequiredFields["studentFirstName_bil"] = dataForQB.studentFirstName_bil;
    col2RequiredFields["studentLastName_bil"] = dataForQB.studentLastName_bil;
    col2RequiredFields["DOB_bil"] = dataForQB.DOB_bil;
    col2RequiredFields["grade_bil"] = dataForQB.grade_bil;
    col2RequiredFields["childResidesWith_bil"] = dataForQB.childResidesWith_bil;
    col2RequiredFields["mfg1_bil"] = dataForQB.mfg1_bil;
    col2RequiredFields["mfgName1_bil"] = dataForQB.mfgName1_bil;
    if (col2RequiredFields["childResidesWith_bil"] == "Other") col2RequiredFields["childsResidesWithOther_bil"] = dataForQB.childsResidesWithOther_bil;
    col2RequiredFields["homeAddress_bil"] = dataForQB.homeAddress_bil;
    col2RequiredFields["homeNum_bil"] = dataForQB.homeNum_bil;
    col2RequiredFields["nativeLanguage_bil"] = dataForQB.nativeLanguage_bil;
    col2RequiredFields["nativeLanguageOther_bil"] = dataForQB.nativeLanguageOther_bil;
    col2RequiredFields["districtDropdown_bil"] = dataForQB.districtDropdown_bil;
    col2RequiredFields["schoolDropdown_bil"] = dataForQB.schoolDropdown_bil;

    if (id == "coser_bil") dataForQB.coser_bil = valueInInput;

    let allFilledOut = true;
    var stringTest = "";
    for (var key in col2RequiredFields) {
      //console.log("key " + key + " has value " + col2RequiredFields[key]);
      if (key == id) {
        col2RequiredFields[key] = valueInInput
        // Set the POST obj
        dataForQB[key] = valueInInput;
      }
      if (col2RequiredFields[key] == "") {
        if (key == "childsResidesWithOther_bil"  && col2RequiredFields["childResidesWith_bil"] != "Other") continue;
        if (key == "nativeLanguageOther_bil"  && col2RequiredFields["nativeLanguage_bil"] != "Other") continue;
        allFilledOut = false;
        stringTest += key.toString();
      }
      
    }
    console.log("STRING TEST: " + stringTest);
    if (id == "districtDropdown_bil") {
      setCurrentDistrict(valueInInput)
      //setCurrentDistrict("Babylon")
    }
    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent();

    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log("QB DATA POST OBJECT CHANGED")
    console.log("-=-=-=-=-=-=-=-=-=-")
    console.log(dataForQB)
    console.log("-=-=-=-=-=-=-=-=-=-")
  }
  const renderColumn2ColumnStatus = () => {
    return <ColumnStatus complete={column2Complete} />
  }
  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  const resetDropdownValOnConditionalChange = (label) =>{
    dataForQB[label] = "";
  }

  //const progressBarData = { bgcolor: "#00695c", completed: 0 }
  //const [progressBarPercent, setProgressBarPercent] = useState(0)

  const setProgressBarDataInParent = () => {
    let temp = 0;    
    if (col2RequiredFields.studentFirstName_bil != "") temp += 9;
    if (col2RequiredFields.studentLastName_bil != "") temp += 9;
    //if (col2RequiredFields.countryOfOrigin_bil != "") temp += 7;
    if (col2RequiredFields.DOB_bil != "") temp += 8;
    //if (col2RequiredFields.yearsInUS_bil != "") temp += 7;
    if (col2RequiredFields.grade_bil != "") temp += 8;
    if (col2RequiredFields.childResidesWith_bil != "") temp += 8;
    if (col2RequiredFields.mfg1_bil != "") temp += 8;
    if (col2RequiredFields.mfgName1_bil != "") temp += 8;
    //if (col2RequiredFields.mfg2_bil != "") temp += 5;
    //if (col2RequiredFields.mfgName2_bil != "") temp += 5;
    if (col2RequiredFields.childResidesWith_bil != "Other" || 
        col2RequiredFields.childsResidesWithOther_bil != "") temp += 2;
    if (col2RequiredFields.homeAddress_bil != "") temp += 8;
    if (col2RequiredFields.homeNum_bil != "") temp += 8;
    //if (col2RequiredFields.workNum_bil != "") temp += 1;
    //if (col2RequiredFields.cellNum_bil != "") temp += 1;
    if (col2RequiredFields.nativeLanguage_bil != "") temp += 8;
    if (col2RequiredFields.nativeLanguageOther_bil != "") temp += 2;
    if (col2RequiredFields.districtDropdown_bil != "") temp += 8;
    if (col2RequiredFields.schoolDropdown_bil != "") temp += 8;
    handleProgressBarChange(parseInt(temp))
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column2Complete]);

  //////////////////////////////////////////////////////////////
  // Other Lang
  //////////////////////////////////////////////////////////////
  useEffect(() => {
    const timer = setTimeout(() => {
      if (renderOtherLang){
        if (!col2RequiredFields.nativeLanguageOther_bil) {
          col2RequiredFields.nativeLanguageOther_bil = '';
        }
      }
      else{
        delete col2RequiredFields['nativeLanguageOther_bil'];
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [renderOtherLang]);
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Other Child Resides With
  //////////////////////////////////////////////////////////////
  useEffect(() => {
    const timer = setTimeout(() => {
      if (renderOtherWhom){
        if (!col2RequiredFields.childsResidesWithOther_bil) {
          col2RequiredFields.childsResidesWithOther_bil = '';
        }
      }
      else{
        delete col2RequiredFields['childsResidesWithOther_bil'];
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [renderOtherWhom]);
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  //  Due Date
  //////////////////////////////////////////////////////////////
  const [startDueDate, setStartDueDate] = useState('')
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Validations
  //////////////////////////////////////////////////////////////approver email
  const [validate_contactPhone, setValidation_contactPhone] = useState('')
  const [validate_contactEmail, setValidation_contactEmail] = useState('')
  const [validate_approverEmail, setValidation_approverEmail] = useState('')
  const [validate_coser, setValidation_coser] = useState('')
  // Actuals
  const [validate_yearsInUS, setValidate_yearsInUS] = useState('')
  const [validate_homePhone, setValidation_homePhone] = useState('')
  function runAllValidations (){
    dataForQB.assessmentRunOnce = false;
    let passed = true;
    let tempAlertText = "";
    // Years in US
    //if (!validateNumber(col2RequiredFields.yearsInUS_bil) && col2RequiredFields.yearsInUS_bil != "") {
    //  setValidate_yearsInUS('*Please provide a number only')
    //  passed = false;
    //}
    //else setValidate_yearsInUS('')
    // Student Home Phone
    if (!validatePhone(assessmentState.homeNum_bil) || assessmentState.homeNum_bil == "") {
      setValidation_homePhone('*Please provide a 10 digit phone')
      tempAlertText += "- Phone #: must be a valid phone number\n";
      passed = false;
    }
    else setValidation_homePhone('')
    // coser
    if (assessmentState.districtDropdown_bil.includes("Nassau BOCES")){
      if (!validateCOSER(assessmentState.coser_bil)) {
        setValidation_coser('*Please provide a valid 3 digit coser')
        tempAlertText += "- COSER: Must be your 3 digit COSER\n";
        passed = false;
      }
      else setValidation_coser('')
    }else setValidation_coser('')
    

    if (passed){
      handleThisContinueButton("assessmentPage2")
    }
    else{
      alert("Cannot proceed, the following fields must be corrected:\n"+tempAlertText);
    }
  }
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validatePhone(phone){
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

    if(phone.match(phoneno)) return true;
    else return false;
  }
  function validateCOSER(coser){
    var coserno = /^\d{3}$/
    if(coser.match(coserno)) return true;
    else return false;
  }
  function validateNumber(num){
    if (isNaN(num)) return false;
    else return true;
  }


  if (!dataForQB.assessmentRunOnce){
    dataForQB.assessmentRunOnce = true;
    setTimeout(function(){
      //updateColumn1Count();
      //updateColumn2Count();
      //alert("RUNNNING")
      checkCol2AtStart();
    },500)
      console.log(col2RequiredFields)
  }
  const checkCol2AtStart = () =>{
    col2RequiredFields["studentFirstName_bil"] = dataForQB.studentFirstName_bil;
    col2RequiredFields["studentLastName_bil"] = dataForQB.studentLastName_bil;
    //col2RequiredFields["countryOfOrigin_bil"] = dataForQB.countryOfOrigin_bil;
    col2RequiredFields["DOB_bil"] = dataForQB.DOB_bil;
    //col2RequiredFields["yearsInUS_bil"] = dataForQB.yearsInUS_bil;
    col2RequiredFields["grade_bil"] = dataForQB.grade_bil;
    col2RequiredFields["childResidesWith_bil"] = dataForQB.childResidesWith_bil;
    col2RequiredFields["mfg1_bil"] = dataForQB.mfg1_bil;
    col2RequiredFields["mfgName1_bil"] = dataForQB.mfgName1_bil;
    if (col2RequiredFields["childResidesWith_bil"] == "Other") col2RequiredFields["childsResidesWithOther_bil"] = dataForQB.childsResidesWithOther_bil;
    col2RequiredFields["homeAddress_bil"] = dataForQB.homeAddress_bil;
    col2RequiredFields["homeNum_bil"] = dataForQB.homeNum_bil;
    col2RequiredFields["nativeLanguage_bil"] = dataForQB.nativeLanguage_bil;
    col2RequiredFields["nativeLanguageOther_bil"] = dataForQB.nativeLanguageOther_bil;
    col2RequiredFields["districtDropdown_bil"] = dataForQB.districtDropdown_bil;
    col2RequiredFields["schoolDropdown_bil"] = dataForQB.schoolDropdown_bil;
    var allFilledOut = true;
    for (var key in col2RequiredFields) {
      console.log("KEY: " + key)
      if (col2RequiredFields[key] == "") {
        if (key == "childsResidesWithOther_bil"  && col2RequiredFields["childResidesWith_bil"] != "Other") continue;
        if (key == "nativeLanguageOther_bil"  && col2RequiredFields["nativeLanguage_bil"] != "Other") continue;
        console.log(col2RequiredFields[key] + "FAILED")
        allFilledOut = false;
      }
      
    }
    console.log("FILLED OUT: " + allFilledOut)
    setColumn2Complete(allFilledOut)
    setProgressBarDataInParent()
  }

  setTimeout(function(){
    updateColumn2Count()
  },600)
  
  //////////////////////////////////////////////////////////////
   useEffect(() => {
      window.scrollTo(0, 0)
    }, []);
    //////////////////////////////////////////////////////////////
    // Mapping
    const mapToRedux = (id, valueInInput) => {
      switch (id) {
        case "studentFirstName_bil":
          dispatch(studentFirstName_bilUpdated(valueInInput))
          break;
        case "studentLastName_bil":
          dispatch(studentLastName_bilUpdated(valueInInput))
          break;
        case "DOB_bil":
          dispatch(DOB_bilUpdated(valueInInput.toISOString()))
          break;
        case "countryOfOrigin_bil":
          dispatch(countryOfOrigin_bilUpdated(valueInInput))
          break;
        case "yearsInUS_bil":
          dispatch(yearsInUS_bilUpdated(valueInInput))
          break;
        case "nativeLanguage_bil":
          dispatch(nativeLanguage_bilUpdated(valueInInput))
          break;
        case "nativeLanguageOther_bil":
          dispatch(nativeLanguageOther_bilUpdated(valueInInput))
          break;
        case "grade_bil":
          dispatch(grade_bilUpdated(valueInInput))
          break;
        case "districtDropdown_bil":
          dispatch(districtDropdown_bilUpdated(valueInInput))
          break;
        case "schoolDropdown_bil":
          dispatch(schoolDropdown_bilUpdated(valueInInput))
          break;
        case "coser_bil":
          dispatch(coser_bilUpdated(valueInInput))
          break;
        case "childResidesWith_bil":
          dispatch(childResidesWith_bilUpdated(valueInInput))
          break;
        case "mfg1_bil":
          dispatch(mfg1_bilUpdated(valueInInput))
          break;
        case "mfgName1_bil":
          dispatch(mfgName1_bilUpdated(valueInInput))
          break;
        case "mfg2_bil":
          dispatch(mfg2_bilUpdated(valueInInput))
          break;
        case "mfgName2_bil":
          dispatch(mfgName2_bilUpdated(valueInInput))
          break;
        case "homeAddress_bil":
          dispatch(homeAddress_bilUpdated(valueInInput))
          break;
        case "homeNum_bil":
          dispatch(homeNum_bilUpdated(valueInInput))
          break;
        case "workNum_bil":
          dispatch(workNum_bilUpdated(valueInInput))
          break;
        case "cellNum_bil":
          dispatch(cellNum_bilUpdated(valueInInput))
          break;
        case "childsResidesWithOther_bil":
          dispatch(childsResidesWithOther_bilUpdated(valueInInput))
          break;
        default:
          alert("ID not found: " + id)
      }
    }
    //////////////////////////////////////////////////////////////

  return (
    <ThemeProvider theme={useStyles}>
      <div className='progress-bar-container'>
        <ProgressBar 
          key={0} 
          bgcolor={"#00695c"}
          completed={assessmentState.page1ProgressBar} 
          fixedClass={progressBarClass}
          isDisabed={false}
          runAllValidations={runAllValidations}
        />
        
        <MySectionBlock 
          height="5px" 
          onEnterViewport={() => {
              console.log('enter viewportttt')
              setProgressBarClass('')
          }}
          onLeaveViewport={() => {
              console.log('leave viewportttt')
              setProgressBarClass('progressBar-fixed')
          }}
        />
     </div>
    <div>{/* className={classes.root}>*/}
    {
        isCutoff ? (
      <FadeIn delay={200} duration={450}>      
        <Container fluid className="">
          <Row>
            <Col>
              <p style={{width: '40%', border: "1px solid black", borderRadius: '4px', backgroundColor: "#F8F8F8", padding: "14px", textAlign: "left", fontSize: "14pt", paddingTop: "10px"}}>
                - May 20th was last day to submit Bilingual Assessments<br/>- Submission will resume on July 1
              </p>
            </Col>
          </Row>
        </Container></FadeIn>) : (
      
      <FadeIn delay={200} duration={450}>
          <Container fluid className="">
            {/* Content */}
            <Row>
              
              <Row>
                <Box style={{width: '60%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
                  <Card variant="outlined" style={{padding: '10px',}}>
                    <CardContent>
                {/* Left Column */}
                <Col>
                  {/*<Row>
                    <Col>{renderColumn1ColumnStatus()}</Col>
                  </Row>*/}
                  <Row>
                    <Col><p style={{color: "rgb(252, 71, 71)", fontWeight: "700", textAlign: "left", marginTop: "5px", fontSize: '11pt'}}>* PLEASE NOTE: BILINGUAL ASSESSMENTS ARE ALLOTTED 5-WEEKS TO COMPLETE AND RETURN TO DISTRICT</p></Col>
                  </Row>

                  <Row>
                      <Col>
                      <p className="assessment-section-headers">DISTRICT INFORMATION</p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                        <Dropdown_Advanced required={true} valueInField={assessmentState.districtDropdown_bil} classesToAdd={"required-adjusted-lower"} options={districts} prompt='District' id="districtDropdown_bil" label="name" triggerUpdateInParent={mapToRedux} />
                        &nbsp;&nbsp; {/*lazy*/}
                        <Dropdown_Advanced valueInField={assessmentState.schoolDropdown_bil} classesToAdd={"required-adjusted-lower"} options={schools} condReset={resetDropdownValOnConditionalChange}
                          prompt='School' id="schoolDropdown_bil" label="name" triggerUpdateInParent={mapToRedux} required={true}
                          isConditional={true} conditionalField={assessmentState.districtDropdown_bil} />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px', marginBottom: '12px'  }}>
                        {
                          assessmentState.districtDropdown_bil.includes("Nassau BOCES") && <TextFields_Outlined valueInField={assessmentState.coser_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="coser_bil" label="COSER (ex: 602)" />
                        }
                        </div>
                      </Col>
                  </Row>

                  <Row>
                      <Col>
                      <p className="assessment-section-headers">STUDENT INFORMATION</p>
                      </Col>
                  </Row>
                  
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left' }}>
                            <DatePicker_Advanced required={true} maxDate={new Date()} valueInField={assessmentState.DOB_bil} classesToAdd={"required-adjusted-date"} triggerUpdateInParent={mapToRedux} id="DOB_bil" className="date-picker-main" label="Date of Birth" selected={startDueDate} onChange={date => setStartDueDate(date)} />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px' }}>
                            <TextFields_Outlined valueInField={assessmentState.studentFirstName_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="studentFirstName_bil" label="Student First Name" />
                            &nbsp;&nbsp; {/*lazy*/}
                            <TextFields_Outlined valueInField={assessmentState.studentLastName_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="studentLastName_bil" label="Student Last Name" />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px' }}>
                          <TextFields_Outlined valueInField={assessmentState.countryOfOrigin_bil} required={false} triggerUpdateInParent={mapToRedux} id="countryOfOrigin_bil" label="Country of Origin" />
                          &nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.yearsInUS_bil} validationText={validate_yearsInUS} required={false} triggerUpdateInParent={mapToRedux} id="yearsInUS_bil" label="Year in US" />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                          <Dropdown_Advanced valueInField={assessmentState.nativeLanguage_bil} classesToAdd={"required-adjusted-lower"}  required={true} options={languages} prompt='Native Language' renderOther={setRenderOtherLang} id="nativeLanguage_bil" label="name" triggerUpdateInParent={mapToRedux} />   
                        </div>
                      </Col>
                      
                  </Row>
                  {
                    assessmentState.nativeLanguage_bil == "Other" ?
                    <Row>
                        <Col>
                          <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                            <TextFields_Outlined valueInField={assessmentState.nativeLanguageOther_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="nativeLanguageOther_bil" label="Other Language" />
                          </div>
                        </Col>
                    </Row> :
                    <></>
                  }
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                          <Dropdown_Advanced valueInField={assessmentState.grade_bil} classesToAdd={"required-adjusted-lower"} required={true} options={grades} prompt='Grade' id="grade_bil" label="name" triggerUpdateInParent={mapToRedux} />
                        </div>
                        <br/>
                      </Col>
                      
                  </Row>


                  <Row>
                      <Col>
                      <p className="assessment-section-headers">STUDENT RESIDENCY</p>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                            <Dropdown_Advanced  required={true} valueInField={assessmentState.childResidesWith_bil} classesToAdd={"required-adjusted-lower"} options={whom_child_resides} prompt='Child resides with whom?' renderOther={setRenderOtherWhom} id="childResidesWith_bil" label="name" triggerUpdateInParent={mapToRedux} />
                        </div>
                      </Col>
                  </Row>
                  {
                    assessmentState.childResidesWith_bil == "Other" ?
                    <Row>
                        <Col>
                          <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                              <TextFields_Outlined valueInField={assessmentState.childsResidesWithOther_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="childsResidesWithOther_bil" label="Please specify" />
                          </div>
                        </Col>
                    </Row>
                    :
                    <></>
                  }
                  <Row>
                    <Col>
                      <div className='assessment-section-body' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                        <Dropdown_Advanced  required={true} valueInField={assessmentState.mfg1_bil} classesToAdd={"required-adjusted-lower"} options={motherFatherGuardian} prompt='Whom 1' id="mfg1_bil" label="name" triggerUpdateInParent={mapToRedux} />
                        &nbsp;&nbsp; {/*lazy*/}
                        <TextFields_Outlined valueInField={assessmentState.mfgName1_bil} classesToAdd={"required-adjusted-lower"} required={true} triggerUpdateInParent={mapToRedux} id="mfgName1_bil" label="Full Name 1" />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                        <div className='assessment-section-body'  style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                          <Dropdown_Advanced required={false} valueInField={assessmentState.mfg2_bil} options={motherFatherGuardian} prompt='Whom 2' id="mfg2_bil" label="name" triggerUpdateInParent={mapToRedux} />
                          &nbsp;&nbsp; {/*lazy*/}
                          <TextFields_Outlined valueInField={assessmentState.mfgName2_bil} required={false} triggerUpdateInParent={mapToRedux} id="mfgName2_bil" label="Full Name 2" />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'  style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                        <TextFields_Outlined valueInField={assessmentState.homeAddress_bil} classesToAdd={"required-adjusted-lower"} extraClasses="width-400px" required={true} triggerUpdateInParent={mapToRedux} id="homeAddress_bil" label="Home Address" />
                        </div>
                      </Col>
                  </Row>
                  <Row>
                      <Col>
                        <div className='assessment-section-body'  style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left', marginTop: '12px'  }}>
                        <TextFields_Outlined valueInField={assessmentState.homeNum_bil} classesToAdd={"required-adjusted-lower"} noSpaces={true} required={true} validationText={validate_homePhone} triggerUpdateInParent={mapToRedux} id="homeNum_bil" label="Phone #" />
                        &nbsp;&nbsp; {/*lazy*/}
                        <TextFields_Outlined valueInField={assessmentState.workNum_bil} classesToAdd={"unrequired-adjusted-lower"} noSpaces={true} validationText={validate_homePhone} triggerUpdateInParent={mapToRedux} id="workNum_bil" label="Work #" />
                        &nbsp;&nbsp; {/*lazy*/}
                        <TextFields_Outlined valueInField={assessmentState.cellNum_bil} classesToAdd={"unrequired-adjusted-lower"} noSpaces={true} validationText={validate_homePhone} triggerUpdateInParent={mapToRedux} id="cellNum_bil" label="Cell #" />
                        {/*<TextFields_Outlined required={true} triggerUpdateInParent={updateColumn2Count} id="workNum_bil" label="Work #" />
                        <TextFields_Outlined required={true} triggerUpdateInParent={updateColumn2Count} id="cellNum_bil" label="Cell #" />*/}
                        </div>
                      </Col>
                  </Row>
                  
                  
                </Col>
              </CardContent>
              </Card>
              </Box>
              </Row>{/*end*/}
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row><Col>&nbsp;</Col></Row>

            <Row>
              <Col className="col-sm-12">
              </Col>
            </Row>

          </Container>
          <div className="form-button-bottom-container">
            <Button className="btn btn-primary form-button-bottom" onClick={() => runAllValidations()} disabled={assessmentState.page1ProgressBar < 100}
              variant="contained" color="primary">
              Next Page
            </Button>
          </div>
      
      </FadeIn>
      )}
    </div>
    </ThemeProvider>
  )
}

export default BilingualAssessmentContent
